import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
import Store from '../../../Store/Store';
import { resolveMemberUserId } from '../ui/emTelUtils';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import { M_EMT_BASIC_01_Schema } from './M_EMT_BASIC_01_Schema';

/** 비상연락망 조회 GetEmTelR1 (부서별) */
export const useSearch1 = (options = {}) => {
  const { depCd = '', enabled = true, onSuccess } = options;
  const params = mapParamsBySchema(M_EMT_BASIC_01_Schema.mapper.search1, {
    depCd,
  });

  const query = useQuery({
    queryKey: ['EmergencyTel', 'Basic01', 'GetEmTelR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.EmergencyTel.GetEmTelR1, params),
    enabled,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 부서 목록 조회 getDepLast */
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_EMT_BASIC_01_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['EmergencyTel', 'Basic01', 'getDepLast', params],
    queryFn: () => apiRequest('post', Global.urls.Utility.getDepLast, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 인원 선택 GetPerCustomR4 */
export const useSearch3 = (options = {}) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_EMT_BASIC_01_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Permit.getPerCustomR4, params);
  }, options);
};

/** 비상연락망 등록/해제 SaveEmTelU1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (context) => {
    const userInfo = context.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const rawItems = Array.isArray(context.items)
      ? context.items
      : context.targetUserId
        ? [context]
        : [];

    const queryParams = mapParamsBySchema(M_EMT_BASIC_01_Schema.mapper.save1, {
      ...context,
      userInfo,
    });

    const body = rawItems
      .map((item) =>
        mapParamsBySchema(M_EMT_BASIC_01_Schema.mapper.save1BodyItem, {
          ...item,
          targetUserId:
            item.targetUserId ??
            item.TargetUserId ??
            resolveMemberUserId(item),
        })
      )
      .filter((item) => item.targetUserId);

    if (body.length === 0) {
      throw new Error('등록할 대상 사용자 ID가 없습니다.');
    }

    if (!queryParams.UserId || !queryParams.CustCd || !queryParams.DepCd) {
      throw new Error('저장에 필요한 사용자/사업장/부서 정보가 없습니다.');
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${Global.base.useUrl}${Global.urls.EmergencyTel.SaveEmTelU1}?${queryString}`;
    const { data } = await Commons.Axios('post1', url, body);
    return data;
  }, options);
};
